module.exports = __webpack_public_path__ + "assets/images/cone-de-transito_3a256a90cad78d91a2e2b663af2c6c94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/cone/cone-de-transito.png
// module id = 194
// module chunks = 0